















































import S from '@/service';
import { Component, Watch } from 'vue-property-decorator';
import { Button } from 'ant-design-vue';
import { namespace } from 'vuex-class';
import Guide from '../../js/guide';
import BaseTab from '../../components/common/BaseTabs.vue';
import empty from '../../../../components/com-empty.vue';

const lessonDialogModule = namespace('lessonDialog');

@Component({
  components: {
    AButton: Button,
    BaseTab,
    empty,
  },
})
export default class Index extends Guide {
  @lessonDialogModule.Action('getLessons') getLessons: any

  @lessonDialogModule.Mutation('updateCurrentClass') updateCurrentClass: any

  @lessonDialogModule.Mutation('updateVisible') updateVisible: any

  // tab 标签内容定义
  private tabs: any[] = [
    { id: 1, name: '课程' },
    // { id: 2, name: '班级' },
  ];

  labelResource: any = {
    1: '自研',
    2: '三阶课',
    3: '短线课',
    4: '公开课',
    5: '双师',
    6: 'AI',
    7: '超级课件',
  }

  // 课程列表
  private courseList: any[] = []

  // 获取多页默认参数
  private defaultParam = {
    pageSize: 9,
    pageNum: 0,
    totalPage: 1,
  }

  // 是否允许加载更多
  private allowShowMore: boolean = true

  // 班级列表
  private classList: any[] = []

  // 当前选中tab 索引
  private activeIndex: number = 1;

  // 滚动条是否到底部标志
  private isAchiveBottom: boolean = false

  @Watch('$route')
  handleRouter(newVal: any, oldVal: any) {
    if (oldVal && oldVal.name === 'Search') {
      // window.removeEventListener('scroll', this.onScroll);
    }
    if (newVal && newVal.name === 'Search') {
      // window.addEventListener('scroll', this.onScroll);
      this.handleGetMoreClassTypeList(1);
    }
  }

  // 点击tab的回调方法
  private updateSubject(id: number) {
    if (id === 1) {
      // todo 调用课程接口
      // console.log('课程列表');
    } else if (id === 2) {
      // todo 调用班级列表
      // console.log('班级列表');
    }
    this.activeIndex = id;
  }

  // 返回上一层路由
  private handleGoBack() {
    const HistoryRouteName = 'History';
    const IndexRouteName = 'Index';
    if (this.$route.query.backPath === HistoryRouteName) {
      this.$router.push({
        path: '/history',
      });
    } else if (this.$route.query.backPath === IndexRouteName) {
      this.$router.push({
        path: '/index',
      });
    } else {
      this.$router.push({
        path: '/history',
      });
    }
  }

  // 调用加载更多接口
  private async handleGetMoreClassTypeList(pageNum: number) {
    const params = {
      ...this.defaultParam,
      classTypeName: this.$route.query.value,
      pageNum,
    };
    if (params.pageNum > params.totalPage) return;
    await S.bk.searchClassType(params)
      .then((result: any) => {
        if (result.pageNumber === 1) {
          this.courseList = [];
          this.defaultParam = {
            pageSize: 9,
            pageNum: 0,
            totalPage: 1,
          };
        }
        this.courseList.push(...result.list);
        this.defaultParam.totalPage = result.totalPage;
        this.defaultParam.pageNum = result.pageNumber;
      }).catch(() => {
        // console.log('err', err);
        this.courseList = [];
      });
  }

  // 点击班型获取讲次
  private handleShowLessonDialog(classType: any) {
    const data = {
      businessId: classType.id,
      type: 2, // 类型：1,班级;2,班型
      newDiyFlag: classType.newDiyFlag,
    };
    const currentClass = {
      ...classType,
      businessId: classType.id,
      type: 2,
      classTypeId: classType.id,
    };
    Promise.resolve(this.getLessons(data)).then(() => {
      this.updateCurrentClass(currentClass);
      this.updateVisible(true);
    });
  }

  // private onScroll() {
  //   // 变量scrollTop是滚动条滚动时，距离顶部的距离
  //   const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  //   // 变量windowHeight是可视区的高度
  //   const windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
  //   // 变量scrollHeight是滚动条的总高度
  //   const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
  //   // 滚动条到底部的条件(距底部20px时触发加载)
  //   if (
  //     scrollTop + windowHeight >= scrollHeight - 45
  //     && !this.isAchiveBottom
  //     && (this.courseList.length > 0)
  //     && !(this.defaultParam.pageNum + 1 > this.defaultParam.totalPage)
  //   ) {
  //     // console.log(
  //     //   `距顶部${
  //     //     scrollTop
  //     //   }可视区高度${
  //     //     windowHeight
  //     //   }滚动条总高度${
  //     //     scrollHeight}`,
  //     // );
  //     this.isAchiveBottom = true;
  //     // 延时触发数据加载
  //     setTimeout(() => {
  //       // 后端需要进行分页，然后前端从后端拿来实现滚动加载
  //       this.handleGetMoreClassTypeList(this.defaultParam.pageNum + 1);
  //       this.isAchiveBottom = false;
  //     }, 500);
  //   }
  // }

  private created() {
    // window.addEventListener('scroll', this.onScroll);
    this.handleGetMoreClassTypeList(1);
  }
}
